<template>
  <div id="app">
    <p>
      <input class="input" v-model.trim="query" type="text"/>
    </p>

    <ul>
      <li v-for="item in searched">
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>

  import algoliasearch from 'algoliasearch'

  var client = algoliasearch('LBNM56J6IX', '50d136751152d23c15a84aff85175aec')
  var index = client.initIndex('getstarted_actors')

  export default {
  name: 'app',
  data() {
    return {
      query: '',
      searched: []
    }
  },
  watch: {
    query: function (val) {
      if(val === '') {
        this.searched = []
      }else {
        index.search(val, function (err, content) {
          if (err) {
            throw err
          }
          this.searched = content.hits
        }.bind(this))

      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// App.vue?339f4b60